document.addEventListener('click', function (event) {
  const tab = event.target.closest('.rp-info-tabs__tab');
  if (!tab) return;

  const wrapper = tab.closest('[data-rp-info-tabs]');
  if (!wrapper) return;

  const selectedTab = tab.dataset.tab;

  wrapper.querySelectorAll('.rp-info-tabs__tab').forEach(function (button) {
    const isActive = button === tab;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  wrapper.querySelectorAll('.rp-info-tabs__panel').forEach(function (panel) {
    panel.classList.toggle('is-active', panel.dataset.panel === selectedTab);
  });
});